import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BankService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get(`${environment.url}/banks?itemsPerPage=10000`).pipe(map((res: any) => res['hydra:member'])) as Observable<
      any[]
    >;
  }

  getById(id: number) {
    return this.http.get(`${environment.url}/banks/${id}`) as Observable<
      any
    >;
  }
}
